<template>
  <Label
    v-bind="props"
    :class="
      cn(
        'block text-sm leading-5 tracking-tight font-semibold text-left text-neutral-300',
        props.class
      )
    "
  >
    <slot />
  </Label>
</template>

<script>
import { Label } from 'radix-vue';
import { cn } from '../../utils.js';

export default {
  components: {
    Label,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    return { props, cn };
  },
};
</script>
